import {publicURL} from "sancus-client-common/dist/common/contextPath";
//@ts-ignore
__webpack_public_path__ = publicURL